export const lowercaseFirstLetter = (str: string) =>
  str.replace(/^./, str[0].toUpperCase());

export const getDocumentFormat = (documentId: string, documentType: string) => {
  if (documentType === 'CE') return documentId.replace(/^(0+)/g, '');
  return documentId;
};

export const getIdDocumentType = (documentType: string) =>
  documentType === 'DNI' ? 1 : 3;

export const hasContactPoint = (phone: string, email: string | undefined) => {
  let contactPoint: any = [];
  const phoneContact = {
    tipoMedioContacto: 'PHONE',
    principal: 'N',
    numeroTelefono: phone,
    codigoTelefonoPais: '51',
  };

  const emailContact = {
    tipoMedioContacto: 'EMAIL',
    correo: email,
  };

  if (phone) {
    contactPoint.push(phoneContact);
  }

  if (email) {
    contactPoint.push(emailContact);
  }

  return contactPoint;
};
